import service from "../services/remissionPaymentEvidences.service";

export const remissionPaymentEvidences = {
    namespaced: true,
    state: {
        data: [],
        loading: false,
    },
    getters: {
        allData: (state) => state.data,
        loading: (state) => state.loading,
    },
    actions: {
        async getAll({ commit }, params = null) {
            try {
                commit('SET_LOADING', true);
                const response = await service.getAll(params);
                commit('SET_DATA', response.data);
                return response.data;
            } catch (error) {
                console.error("Error fetching remission payment evidences:", error);
                throw error.response;
            } finally {
                commit('SET_LOADING', false);
            }
        },
        async save(context, data) {
            try {
                let response;
                if (data.id === 0 || !data.id) {
                    response = await service.createData(data);
                } else {
                    response = await service.updateData(data.id, data);
                }
                return response;
            } catch (error) {
                console.error("Error saving remission payment evidence:", error);
                return error.response;
            }
        },
        async delete({ commit }, id) {
            try {
                const response = await service.deleteData(id);
                commit('REMOVE_DATA', id);
                return response;
            } catch (error) {
                throw error.response;
            }
        },
    },
    mutations: {
        SET_DATA(state, data) {
            state.data = data;
        },
        SET_LOADING(state, loading) {
            state.loading = loading;
        },
        REMOVE_DATA(state, id) {
            state.data = state.data.filter(item => item.id !== id);
        },
        ADD_DATA(state, data) {
            state.data.push(data);
        },
    },
};
